import { config } from 'config/config';
import { NextPageContext } from 'next';
import { Context, createWrapper, HYDRATE, MakeStore } from 'next-redux-wrapper';
import { AnyAction, applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import combineReducers, { IRootReducers } from 'src/reducers';

export interface ReduxPageContext extends NextPageContext {
  store: Store;
}

const bindMiddleware = (middleware) => {
  if (config.APP.ENV === 'local') {
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

const reducer = (state: IRootReducers, action: AnyAction) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
    };

    if (state.auth) {
      // preserve some auth value on client side navigation
      nextState.auth = {
        ...nextState.auth,
        accountStatus: state.auth.accountStatus,
        accountSubscription: state.auth.accountSubscription,
      };
    }

    return nextState;
  } else {
    return combineReducers(state, action);
  }
};

let store: any;

const makeStore: MakeStore<Store<IRootReducers>> = (context: Context) => {
  store = createStore(reducer, bindMiddleware([thunkMiddleware]));
  return store;
};

export { store };

export const wrapper = createWrapper<Store<IRootReducers>>(makeStore, {});
